import { css } from 'lit'

export const polarLoadingModalStyles = css`
    .loading-img {
        width: 200px;
        height: 200px;
    }

    .loader-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin-bottom: 24px;
    }

    p {
        margin: 0;
        text-align: center;
    }

    .loading-text {
        margin-top: 10px;
    }

    .error-text {
        display: block;
        margin-top: 7px;
        font-style: italic;
    }

    .copy-button {
        all: unset;
        color: var(--voyage-blue-dark, #0055aa); /* Default color */
        text-decoration: underline;
        cursor: pointer;
    }

    .error-text-block {
        white-space: pre-line;
    }
`
